import { useState } from 'react';
import { faqList } from '@/pages/home/data';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50">
      <div className="max-w-[1240px] mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-8 lg:gap-12">
          <div>
            <p className="text-xs font-medium tracking-[0.24em] text-primary-600">FAQ</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
              下载安装常见问题
            </h2>
            <p className="mt-3 text-sm text-foreground-500 leading-relaxed">
              整理用户最常遇到的安装与更新问题，点击标题即可展开查看解决办法。
            </p>
            <div className="mt-6 inline-flex items-center gap-3 rounded-xl bg-background-100 border border-background-200 px-4 py-3">
              <span className="w-9 h-9 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                <i className="ri-customer-service-2-line text-lg"></i>
              </span>
              <div>
                <p className="text-sm font-medium text-foreground-900">还是装不上？</p>
                <p className="text-xs text-foreground-500">按上方步骤逐步排查即可</p>
              </div>
            </div>
          </div>

          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqList.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div key={item.q}>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    className="w-full flex items-center justify-between gap-4 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading font-bold text-sm md:text-base text-foreground-900">
                      {item.q}
                    </span>
                    <span
                      className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                        isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                      }`}
                    >
                      <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-11 text-sm leading-relaxed text-foreground-500">{item.a}</p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}